import { ReactElement } from 'react';

import { CREATE_MODAL_TYPES } from '@savgroup-front-common/constants';
import { MessageType } from '@savgroup-front-common/types';

export const CREATE_MENU_ITEM_TYPE = {
  TITLE: 'TITLE',
  LINK: 'LINK',
  BUTTON: 'BUTTON',
} as const;

export type CreateMenuItemType =
  (typeof CREATE_MENU_ITEM_TYPE)[keyof typeof CREATE_MENU_ITEM_TYPE];

interface CreateMenuTitleItem {
  type: typeof CREATE_MENU_ITEM_TYPE.TITLE;
  key: string;
  label: MessageType | string | number;
}

interface CreateMenuLinkItem {
  type: typeof CREATE_MENU_ITEM_TYPE.LINK;
  key: string;
  label: MessageType | string | number;
  icon?: ReactElement;
  href: string | undefined;
  isDisabled?: boolean;
}

export interface CreateMenuButtonItem {
  type: typeof CREATE_MENU_ITEM_TYPE.BUTTON;
  key: string;
  label: MessageType | string | number;
  icon?: ReactElement;
  isDisabled?: boolean;
  onClick: (
    item: CreateMenuButtonItem,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export type CreateMenuItem =
  | CreateMenuTitleItem
  | CreateMenuLinkItem
  | CreateMenuButtonItem;

export enum MODAL_STATE_ACTION_TYPES {
  OPEN_CREATE_MODAL = 'OPEN_CREATE_MODAL',
  CLOSE_CREATE_MODAL = 'CLOSE_CREATE_MODAL',
  TOGGLE_MENU = 'TOGGLE_MENU',
  OPEN_MENU = 'OPEN_MENU',
  CLOSE_MENU = 'CLOSE_MENU',
}

export interface CreateButtonState {
  isMenuOpen: boolean;
  modalType: CREATE_MODAL_TYPES | null;
}

export type CreateButtonAction =
  | {
      type: MODAL_STATE_ACTION_TYPES.CLOSE_CREATE_MODAL;
    }
  | {
      type: MODAL_STATE_ACTION_TYPES.CLOSE_MENU;
    }
  | {
      type: MODAL_STATE_ACTION_TYPES.OPEN_MENU;
    }
  | {
      type: MODAL_STATE_ACTION_TYPES.OPEN_CREATE_MODAL;
      payload: { key: CREATE_MODAL_TYPES };
    }
  | {
      type: MODAL_STATE_ACTION_TYPES.TOGGLE_MENU;
    };
